
export const FETCH_SasData_REQUEST = 'FETCH_SasData_REQUEST';
export const FETCH_SasData_SUCCESS = 'FETCH_SasData_SUCCESS';
export const FETCH_SasData_FAILURE = 'FETCH_SasData_FAILURE';
export const REDIRECT_TO_LOGIN = 'REDIRECT_TO_LOGIN';